import { Injectable, Inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from './api-request.service';
import { HttpParams} from '@angular/common/http';
import {Broadcast} from '../../modules/broadcast';

@Injectable()
export class TrackService {
  constructor(
    private apiRequest: ApiRequestService,
  ) {}


  getTrackings(): Observable<any> {
    const channels = new Subject<any>();
    this.apiRequest.get('downloadinfo')
      .subscribe(jsonResp => {
        channels.next(jsonResp);
      });
    return channels;
  }
}
